import { Search } from "PFCore/initial_state/search";
import { createContext, useContext } from "react";

export type Dispatch = <ACTION extends object>(action: ACTION) => void | Promise<any>;

export type AppContextStore = {
  search: Search;
};

export const AppStoreContext = createContext<AppContextStore>({} as AppContextStore);
export const AppDispatchContext = createContext<Dispatch>(() => {});

export const useAppStoreContext = (): AppContextStore => useContext(AppStoreContext);
export const useAppDispatch = (): Dispatch => useContext(AppDispatchContext);
